import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { ShopInput, ShopOutput } from "types/web-app";

export const purchaseItem = async (
  accessToken: string,
  itemName: string,
  amount: number
) => {
  try {
    const body: ShopInput = {
      item_name: itemName,
      amount: amount,
    };

    const response = await fetchWithAuth("/shop", accessToken, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const data = (await response.json()) as ServiceResponse<ShopOutput>;

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

